import React, { useEffect, useState } from 'react'
import moment from 'moment'
import API from '../../../../services/API'
import {
  Alert,
  AlertTitle,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { useNavigate } from 'react-router-dom'

const FailedChecks = ({ failedCount }) => {
  const [checks, setChecks] = useState([])
  const [loading, setLoading] = useState(true)
  const [skip, setSkip] = useState(0)
  const [count, setCount] = useState(25)

  // TODO: SKIP/COUNT

  const navigate = useNavigate()

  useEffect(() => {
    API.get('/dbs-dashboard/failed-checks').then((res) => {
      if (res.status === 200) {
        setChecks(res.data)
      }
    })
  }, [skip, count])

  if (failedCount === 0) {
    return null
  }

  return (
    <Card sx={{ borderRadius: 3, mb: 3 }}>
      <CardContent>
        <Stack>
          <Typography variant="h6" fontWeight={700}>
            Failed Checks
          </Typography>
          <Alert severity="info">
            <AlertTitle>
              Update Service checks typically fail due to one of the following:
            </AlertTitle>
            <ul>
              <li>
                The certificate has expired or is not on the update service
                <br />
                <i>
                  In this case, the 'Is on Update Service' needs to be disabled
                  on the employee's DBS check
                </i>
              </li>
              <li>The Employee's Surname is incorrect</li>
              <li>The Employee's Date of Birth is incorrect</li>
            </ul>
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Failed checks are often because the certificate is recorded as being
            on the Update Service, but isn't.
          </Typography>
          <CustomDataGrid
            columns={[
              {
                field: 'employee',
                headerName: 'Employee',
                valueGetter: (value, row) =>
                  `${row?.employee?.userAccount?.firstName} ${row?.employee?.userAccount?.lastName} (${row?.employee?.clinicalRole})`,
                minWidth: 220,
                flex: 1,
              },
              {
                field: 'dob',
                headerName: 'Date of Birth',
                valueGetter: (value, row) =>
                  moment(row?.employee?.personnelInfo?.dob).format(
                    'DD/MM/YYYY',
                  ),
                minWidth: 120,
                flex: 0.5,
              },
              {
                field: 'status',
                headerName: 'Status',
                valueGetter: (value, row) =>
                  row?.lastUpdateServiceCheck?.status,
                minWidth: 160,
                flex: 0.5,
              },
            ]}
            rows={checks}
            getRowId={(params) => params._id}
            onRowClick={({ row }) =>
              navigate(`/employees/${row.employee.userAccount._id}`)
            }
          />
        </Stack>
      </CardContent>
    </Card>
  )
}

export default FailedChecks
